import React, { useEffect, useState } from "react";
import "@lottiefiles/lottie-player";
import lottieJson from "../assets/m-2-02.json";
import lottieJson2 from "../assets/mobile-02-v02.json";
import backimage from "../assets/images/big monile-min.png";

const Partition = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [key, setKey] = useState(0); // To force remount

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
      setKey((prevKey) => prevKey + 1); // Change key to force remount
    };

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return (
    <div className="partitionContainer" style={{ width: "100%" }}>
      {!isMobile ? (
        <lottie-player
          key={key} // Force remount when key changes
          src={lottieJson}
          autoplay
          loop={false}
          style={{ width: "100%", height: "100vh" }}
        ></lottie-player>
      ) : (
        // <img src={backimage} alt="back image"/>

        <lottie-player
          key={key} // Force remount when key changes
          src={lottieJson2}
          autoplay
          loop={false}
          style={{ width: "100%", height: "100vh" }}
        ></lottie-player>
      )}

      <div className="partitionContent">
        <h1 data-aos="fade-up" data-aos-duration="2000">
          کنار هم، بزرگـتــــریم
        </h1>
        <p data-aos="fade-up" data-aos-duration="2000">
          فضای جادار و انعطاف‌پذیر برای ذخیره مواد غذایی
        </p>
        <p className="content" data-aos="fade-up" data-aos-duration="2000">
          یخچال و فریزر دوقلوی پاکشوما با طراحی مدرن و فضای بزرگ، امکان
          ذخیره‌سازی بیشتر مواد غذایی را برای شما فراهم می‌کند. قفسه‌های قابل
          تنظیم، تمیز کردن و سازمان‌دهی فضای داخلی را آسان‌تر از همیشه می‌سازند.{" "}
        </p>
      </div>
    </div>
  );
};

export default Partition;
